<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Apply Bank Account') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Create an account tailored to your needs') }}</span>
            </div>

            <step-container
                :current_step="4"
                :step_list="stepList"
            ></step-container>
        </div>
        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0" v-if="init">
                            <div class="mb-0 p-3">
                                <div class="d-flex">
                                    <h5>{{ $t('Beneficiary Information') }}</h5>
                                </div>
                                
                                <div class="mb-0 mt-3">
                                    <div v-for="(item,index) in beneficiary_list" :key="item.id">
                                        <BeneficiaryInfo 
                                            :ref="'beneficiary'+item.id"
                                            @file-uploaded = "fileUploaded"
                                            :information = information
                                            :account_id = account_id
                                            :user_no = user_no
                                            :index="index"
                                            :country="'CHN'"
                                            :is_new="item.is_new"
                                            @on-error = "onError"
                                            :doc_type_list = document
                                            :is_remove = "beneficiary_list.length>1?true:false"
                                        ></BeneficiaryInfo>
                                        <div class="d-flex justi fy-content-end mb-2">
                                            <div class="ml-auto d-flex">
                                                <button v-if="beneficiary_list.length>1" class="d-flex align-items-center btn btn-outline-red" @click="removeItem(item.id)">
                                                    <span>Remove</span>
                                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                                </button>
                                                <button class="btn btn-outline-orange" @click="addBeneficiary">{{ $t('Add') }} +</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <hr>
                <div class="form-group text-justify">
                    <label :for="agree" id="agree" class="d-flex align-items-start justify-content-center">
                        <input v-model="agree" type="checkbox" autocomplete="off" @change="onChange('agree')" class="mt-2">
                        <span class="ml-4 w-100 fz-14">
                            <p><i>{{ $t('agreement-1') }}</i></p>
                            <p><i>{{ $t('agreement-2') }}</i></p>
                            <p><i>{{ $t('agreement-3') }}</i></p>
                        </span>
                    </label>
                    <div v-if="error.agree" class="text-danger d-block">
                        {{$t(error.agree)}}
                    </div>
                </div>
                <b-row>
                    <b-col cols="12" class="d-flex">
                        <router-link to="/china-registered-address" class="btn btn-previous d-block mr-auto" tag="button">{{ $t('Previous') }}</router-link>
                        <button @click="nextStep" class="ml-auto btn btn-primary d-block">{{ $t('Submit') }}</button>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <LoaderComponent v-if="isLoading || (isLoading === false && init === false)"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import BeneficiaryInfo from '@/components/CardManagement/beneficiaryInfo';
    import CreateAccount from '@/services/CreateAccount';
    import Account from '@/services/Account';
  
    export default {
        name: 'china-beneficiary-info',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                init : false,
                agree : false,
                beneficiary_list:[{"id":1}],
                document:[
                    {
                        "id":1,
                        "name":"ID Card"
                    },
                    {
                        "id":2,
                        "name":"Passport"
                    }
                ],
                error:{
                    agree:''
                },
                account_id : '',
                user_no : '',
                information : '',
                stepList:["Basic Information","Legal Information", "Registered Address","Beneficiary Info"],
            }
        },
        components: {
            LoaderComponent,
            stepContainer,
            BeneficiaryInfo
        },
        methods:{
            onChange(name){
                this.error[name]="";
            },
            fileUploaded(){
                let params = {
                    "accountId":this.account_id,
                    "userNo":""+this.user_no,
                    "beneficiaryIdFront":[],
                    "beneficiaryIdReverse":[],
                    "beneficiaryIdType":[],
                    "beneficiaryIdNo":[],
                    "beneficiaryName":[],
                    "beneficiaryBirthDate":[],
                    "beneficiaryCertExpiryDate":[],
                    "beneficiaryCountry":[],
                    "beneficiaryProvince":[],
                    "beneficiaryCity":[],
                    "beneficiaryArea":[],
                    "beneficiaryAddress":[],
                    "beneficiaryShareholderRatio":[]
                }
                
                let is_upload = true;

                for(let i=0;i<this.beneficiary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficiary_list[i].id;
                    if(this.$refs[ref][0].success === false){
                        is_upload = false;
                    }
                    params['beneficiaryIdFront'].push(this.$refs[ref][0].file.beneficiaryIdFront);
                    params['beneficiaryIdReverse'].push(this.$refs[ref][0].file.beneficiaryIdReverse);
                    params['beneficiaryIdType'].push(parseInt(this.$refs[ref][0].params.beneficiaryIdType));
                    params['beneficiaryIdNo'].push(this.$refs[ref][0].params.beneficiaryIdNo);
                    params['beneficiaryName'].push(this.$refs[ref][0].params.beneficiaryName);
                    params['beneficiaryBirthDate'].push(this.$refs[ref][0].params.beneficiaryBirthDate);
                    params['beneficiaryCertExpiryDate'].push(this.$refs[ref][0].params.beneficiaryCertExpiryDate);
                    params['beneficiaryCountry'].push("CHN");
                    params['beneficiaryProvince'].push(this.$refs[ref][0].params.beneficiaryProvince);
                    params['beneficiaryCity'].push(this.$refs[ref][0].params.beneficiaryCity);
                    params['beneficiaryArea'].push(this.$refs[ref][0].params.beneficiaryArea);
                    params['beneficiaryAddress'].push(this.$refs[ref][0].params.beneficiaryAddress);
                    params['beneficiaryShareholderRatio'].push(this.$refs[ref][0].params.beneficiaryShareholderRatio);
                }

                Account.updateChina(params).then(response => {
                    const data = response.data.data;
                    if(is_upload){
                        this.submitData(params);
                    }
                }).catch(err => {
                    this.checkError(err);
                });
            },
            submitData(beneficiary_data){
                let params = {
                    ...this.information,
                    ...beneficiary_data
                };

                CreateAccount.domestic(params).then(response => {
                    const data = response.data.data;
                    this.isLoading = false;
                    this.$swal({
                        icon: 'success',
                        title: 'success',
                        showConfirmButton: true,
                    }).then((result) => {
                        window.parent.location.href = location.protocol+"//"+window.location.hostname;
                    });
                }).catch(err => {
                    this.checkError(err);
                });
            },
            checkError(err){
                let self = this;
                try{
                    this.isLoading = false;
                    const response = err.response;  
                    if(response.status == 400 || response.status == 500){
                        console.log(response.data);
                        if(typeof response.data.message === 'string'){
                            self.$swal({
                                icon: 'info',
                                html:response.data.message,
                                showConfirmButton: true,
                                confirmButtonText: self.$t('OK')
                            });
                        }
                        else{
                            if(response.data.message['errorMsg']){
                                console.log("muncul alert");
                                self.$swal({
                                    icon: 'info',
                                    text:response.data.message['errorMsg'],
                                    showConfirmButton: true,
                                    confirmButtonText: self.$t('OK')
                                });
                            }
                            else{
                                let ret = ["Can not submit, please check your form"];
                               
                                this.$swal({
                                    icon: 'info',
                                    html:ret.join("<br>"),
                                    showConfirmButton: true,
                                    confirmButtonText: self.$t('OK')
                                });
                            }
                        }
                    }      
                    else if(response.status == 401 && response.data.name == "Unauthorized"){
                            localStorage.removeItem("token");
                            localStorage.removeItem("member");
                            localStorage.removeItem("isFirstTime");
                            this.$router.push({ 
                                path: '/login', 
                            });
                    }
                    else{
                        if(localStorage.getItem("token")){
                            var msg = (response.data)?response.data.message:err.message;
                            this.$notify({
                                type: 'warn',
                                text: msg
                            })
                        }
                    }
                }catch(e){
                    console.log(err);
                }
            },
            addBeneficiary(){
                this.beneficiary_list.push({"id":(this.beneficiary_list[this.beneficiary_list.length-1].id+1)});
            },
            removeItem(id) {
                const index = this.beneficiary_list.findIndex(item => item.id === id)
                if (index !== -1) {
                    this.beneficiary_list.splice(index, 1)
                }
            },
            onError(){
                this.isLoading = false;
            },
            nextStep(){
                this.isLoading = true;
                let is_valid = true;

                for(let i=0;i<this.beneficiary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficiary_list[i].id;
                    if(!this.$refs[ref][0].validate()){
                        console.log("beneficiary belum valid");
                        is_valid = false;
                    }
                }

                if(!this.agree){
                    is_valid = false;
                    console.log("agree belum valid");
                    this.error.agree = "must be checked";
                }

                if(is_valid){
                    for(let i=0;i<this.beneficiary_list.length;i++){
                        let ref = 'beneficiary'+this.beneficiary_list[i].id;
                        this.$refs[ref][0].uploadFile(this.account_id,this.user_no);
                        
                    }     
                }
                else{
                    this.isLoading = false;
                }
            }
        },
        mounted() {
            this.init = false;
            this.$nextTick(() => {
                CreateAccount.list({start:0, length:-1}).then((response)=>{
                    if (response.status == 200) {
                        
                        if(response.data.data.length>0){
                            this.account_id = response.data.data[0]['id'];
                            this.user_no = response.data.data[0]['userNo'];
                            this.information = response.data.data[0]['information'];
                            
                            if(this.information['beneficiaryIdNo']){
                                this.beneficiary_list = [];
                                for(let i=0;i<this.information['beneficiaryIdNo'].length;i++){
                                    this.beneficiary_list.push({
                                        "id":(i+1),
                                        "is_new":false
                                    });
                                }
                            }
                        }

                        this.init = true;
                    }
                });
            });
        },
    };
  </script>